import React from 'react';
import PropTypes from 'prop-types';
import useScrollTopOnMount from 'Hooks/useScrollTopOnMount';
import { useSurveyContext } from 'Views/Onboarding/Pages/Survey/SurveyContext';
import FullScreenDataContainer from 'Components/ComponentLibrary/Components/Uncategorized/DataContainer/FullScreenDataContainer';
import SurveyContentPicker from './SurveyContentPicker';

const SurveyContainer = ({ clientResource }) => {
  const {
    isInitializing,
    initializingError,
  } = useSurveyContext();
  useScrollTopOnMount();

  return (
    <FullScreenDataContainer
      component={SurveyContentPicker}
      componentProps={{ clientResource }}
      loading={isInitializing}
      loadingError={initializingError}
      ErrorListProps={{
        title: 'An error occurred while initializing the survey.',
      }}
    />
  );
};

SurveyContainer.propTypes = {
  clientResource: PropTypes.object.isRequired,
};

export default SurveyContainer;
